import React, {forwardRef, useEffect, useState} from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import IcCalendar from "../../assets/icons/ic-calendar.png";
import Button from "../../components/common/Button";
import {toast} from "react-toastify";
import {useStore} from "../../app/store";

const ProductLiveSetTimeModal = ({handleCloseModal, modalDepth}) => {
    const {confirmStore, appEditorStore} = useStore();
    const now = new Date();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [hour, setHour] = useState(now.getHours());
    const [minute, setMinute] = useState(now.getMinutes());
    const isToday = selectedDate.toDateString() === new Date().toDateString();


    const [morning, setMorning] = useState(false);
    const [afternoon, setAfternoon] = useState(false);

    //
    // const updateHour = (value) => {
    //     const num = parseInt(value);
    //     if (!isNaN(num) && num >= 1 && num <= 12) {
    //         const h24 = get12Hour(num, afternoon);
    //         if (isToday && (h24 < now.getHours() || (h24 === now.getHours() && minute < now.getMinutes()))) return;
    //         setHour(num);
    //     }
    // };
    //
    // const updateMinute = (value) => {
    //     const num = parseInt(value);
    //     if (!isNaN(num) && num >= 0 && num <= 59) {
    //         if (isToday && (hour < now.getHours() || (hour === now.getHours() && num < now.getMinutes()))) return;
    //         setMinute(num);
    //     }
    // };

    const incrementHour = () => {
        let newHour = parseInt(hourInput);
        let nextAfternoon = afternoon;
        let nextMorning = morning;

        if (newHour === 12) {
            newHour = 1;
            nextAfternoon = !afternoon;
            nextMorning = !morning;
        } else {
            newHour += 1;
        }

        const h24 = get24Hour(newHour, nextAfternoon); // 상태가 반영된 값으로 계산
        const newDate = new Date(selectedDate);
        newDate.setHours(h24, 0, 0, 0);

        // if (newDate <= now) {
        //     newDate.setDate(newDate.getDate() + 1);
        //     // return;
        // }

        setAfternoon(nextAfternoon);
        setMorning(nextMorning);
        setHour(h24);
        setHourInput(newHour.toString().padStart(2, '0'));
        setMinute(0);
        setMinuteInput('00');
    };


    const decrementHour = () => {
        let newHour = parseInt(hourInput);
        if (newHour === 1) {
            newHour = 12;
            setAfternoon(!afternoon); // 오전 <-> 오후 전환
            setMorning(!morning);
        } else {
            newHour -= 1;
        }
        const h24 = get24Hour(newHour, afternoon);
        const newDate = new Date(selectedDate);
        newDate.setHours(h24, 59, 0, 0);
        if (newDate <= now) return;

        setHour(h24);
        setHourInput(newHour.toString().padStart(2, '0'));
        setMinute(59);
        setMinuteInput('59');
    };


    const incrementMinute = () => {
        let newMinute = parseInt(minuteInput);
        let newHour = parseInt(hourInput);

        if (newMinute + 1 > 59) {
            newMinute = 0;
            incrementHour(); // 시 증가 로직 호출
        } else {
            newMinute += 1;
            const h24 = get24Hour(newHour, afternoon);
            const newDate = new Date(selectedDate);
            newDate.setHours(h24, newMinute, 0, 0);
            if (newDate <= now) return;

            setMinute(newMinute);
            setMinuteInput(newMinute.toString().padStart(2, '0'));
        }
    };


    const decrementMinute = () => {
        let newMinute = parseInt(minuteInput);
        let newHour = parseInt(hourInput);

        if (newMinute - 1 < 0) {
            newMinute = 59;
            decrementHour(); // 시 감소 로직 호출
        } else {
            newMinute -= 1;
            const h24 = get24Hour(newHour, afternoon);
            const newDate = new Date(selectedDate);
            newDate.setHours(h24, newMinute, 0, 0);
            if (newDate <= now) return;

            setMinute(newMinute);
            setMinuteInput(newMinute.toString().padStart(2, '0'));
        }
    };

    const get12Hour = (hour24) => {
        const hour12 = hour24 % 12;
        return hour12 === 0 ? 12 : hour12;
    };

    const handleTimeOfDay = (isAfternoon) => {
        const newHour = get12Hour(hour, isAfternoon);
        if (isToday && (newHour < now.getHours() || (newHour === now.getHours() && minute < now.getMinutes()))) return;

        setAfternoon(isAfternoon);
        setMorning(!isAfternoon);
    };


    useEffect(() => {
        const nowHour = now.getHours();
        const nowMinute = now.getMinutes();

        if (selectedDate.toDateString() === now.toDateString()) {
            const currentTotal = nowHour * 60 + nowMinute;
            const selectedTotal = get12Hour(hour, afternoon) * 60 + minute;

            if (selectedTotal < currentTotal) {
                // 현재 시간 기준 오전/오후, 시, 분 다시 설정
                if (nowHour >= 12) {
                    setAfternoon(true);
                    setMorning(false);
                    setHour(nowHour === 12 ? 12 : nowHour - 12);
                } else {
                    setMorning(true);
                    setAfternoon(false);
                    setHour(nowHour === 0 ? 12 : nowHour);
                }
                setMinute(nowMinute);
            }
        }
    }, [selectedDate]);

    useEffect(() => {
        const currentHour = now.getHours();
        if (currentHour >= 12) {
            setAfternoon(true);
            setMorning(false);
            setHour(currentHour === 12 ? 12 : currentHour - 12);
        } else {
            setMorning(true);
            setAfternoon(false);
            setHour(currentHour === 0 ? 12 : currentHour);
        }
    }, []);

    const CustomInput = forwardRef(({value, onClick}, ref) => (
        <CustomDateInputWrapper>
            <ReadOnlyInput value={value} readOnly ref={ref}/>
            <CalendarButton onClick={onClick}><img src={IcCalendar}/></CalendarButton>
        </CustomDateInputWrapper>
    ));


    const reservePage = async () => {
        try {
            const hour12 = parseInt(hourInput);
            const minute = parseInt(minuteInput);

            if (isNaN(hour12) || isNaN(minute)) {
                toast("시간을 올바르게 입력해 주세요.");
                return;
            }
            const hour24 = get24Hour(hour12, afternoon);
            const reservedDate = new Date(selectedDate);
            reservedDate.setHours(hour24, minute, 0, 0);
            if (reservedDate <= new Date()) {
                toast("현재 시간 이후로만 예약이 가능합니다.");
                return;
            }

            const yyyy = reservedDate.getFullYear();
            const mm = (reservedDate.getMonth() + 1).toString().padStart(2, '0');
            const dd = reservedDate.getDate().toString().padStart(2, '0');
            const hh = reservedDate.getHours().toString().padStart(2, '0');
            const min = reservedDate.getMinutes().toString().padStart(2, '0');

            const formatted = `${yyyy}-${mm}-${dd}T${hh}:${min}:00`;
            await appEditorStore.livePage(formatted);
            await appEditorStore.deleteTempSave();
            handleCloseModal(modalDepth);
            confirmStore.clear();
            toast("예약한시간에 사이트의 \n상품 상세 페이지에 반영됩니다.");
        } catch (e) {
            console.log(`라이브에 실패하였습니다.\n${e.message}`)
        }
    };


    const get24Hour = (hour12, isAfternoon) => {
        if (isAfternoon) {
            return hour12 === 12 ? 12 : hour12 + 12;
        } else {
            return hour12 === 12 ? 0 : hour12;
        }
    };

    const [hourInput, setHourInput] = useState(get12Hour(hour).toString());
    const [minuteInput, setMinuteInput] = useState(minute.toString().padStart(2, '0'));
    useEffect(() => {
        setHourInput(get12Hour(hour).toString().padStart(2, '0'));
        setMinuteInput(minute.toString().padStart(2, '0'));
    }, [hour, minute]);


    return (
        <ModalBody id="ProductLiveSetTime">
            <ProductLiveSetTimeModalWrap>
                <FieldWrap>
                    <Field>
                        <label>시간대 선택</label>
                        <TimeOfDayPicker>
                            <div className={`morning ${morning ? "on" : ""}`}
                                 onClick={() => handleTimeOfDay(false)}>오전
                            </div>
                            <div className={`afternoon ${afternoon ? "on" : ""}`}
                                 onClick={() => handleTimeOfDay(true)}>오후
                            </div>
                        </TimeOfDayPicker>
                    </Field>
                    <Field>
                        <label>날짜 선택</label>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            minDate={now}
                            dateFormat="yyyy-MM-dd"
                            customInput={<CustomInput/>}
                        />
                    </Field>
                    <Field>
                        <label>시간 설정</label>
                        <TimePicker>
                            <TimeControl>

                                <input
                                    type="text"
                                    value={hourInput}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '');
                                        if (val.length <= 2) setHourInput(val);
                                    }}
                                    onBlur={() => {
                                        const num = parseInt(hourInput);
                                        if (!isNaN(num) && num >= 1 && num <= 12) {
                                            const h24 = get24Hour(num, afternoon);
                                            const nowHour = now.getHours();
                                            const nowMinute = now.getMinutes();

                                            if (isToday && (h24 < nowHour || (h24 === nowHour && minute < nowMinute))) {
                                                const currentHour = nowHour;
                                                setHour(currentHour);
                                                setHourInput(get12Hour(currentHour).toString());
                                                setAfternoon(currentHour >= 12);
                                                setMorning(currentHour < 12);
                                                setMinute(nowMinute);
                                                setMinuteInput(nowMinute.toString().padStart(2, '0'));
                                            } else {
                                                setHour(h24);
                                                setHourInput(get12Hour(h24).toString().padStart(2, '0')); // 👈 여기!
                                            }
                                        } else {
                                            // 잘못된 값이면 원래 값으로 되돌림
                                            setHourInput(get12Hour(hour).toString());
                                        }
                                    }}
                                    className={"time_input"}
                                />


                                <span className={"time_sub_text"}>시</span>
                                <div className={"time_control_wrap"}>
                                    <div className={"time_control_btn up"} onClick={incrementHour}></div>
                                    <div className={"time_control_btn dw"} onClick={decrementHour}></div>
                                </div>
                            </TimeControl>
                            <span className={"time_divide"}>:</span>
                            <TimeControl>

                                <input
                                    type="text"
                                    value={minuteInput}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '');
                                        if (val.length <= 2) setMinuteInput(val);
                                    }}
                                    onBlur={() => {
                                        const num = parseInt(minuteInput);
                                        if (!isNaN(num) && num >= 0 && num <= 59) {
                                            const nowHour = now.getHours();
                                            const nowMinute = now.getMinutes();

                                            if (isToday && (hour < nowHour || (hour === nowHour && num < nowMinute))) {
                                                setMinute(nowMinute);
                                                setMinuteInput(nowMinute.toString().padStart(2, '0'));
                                            } else {
                                                setMinute(num);
                                            }
                                        } else {
                                            // 잘못된 값이면 원래 값으로 되돌림
                                            setMinuteInput(minute.toString().padStart(2, '0'));
                                        }
                                    }}
                                    className={"time_input"}
                                />


                                <span className={"time_sub_text"}>분</span>
                                <div className={"time_control_wrap"}>
                                    <div className={"time_control_btn up"} onClick={incrementMinute}></div>
                                    <div className={"time_control_btn dw"} onClick={decrementMinute}></div>
                                </div>
                            </TimeControl>
                        </TimePicker>
                    </Field>
                </FieldWrap>

                <div className={"btn_area"}>
                    <Button
                        type={"outline"}
                        size={"s"}
                        text={"취소"}
                        onClickFunc={() => {
                            handleCloseModal(modalDepth);
                        }}
                    />
                    <Button
                        text={"라이브 예약"}
                        size={"s"}
                        onClickFunc={reservePage}
                        type={"fill"}
                    />
                </div>
            </ProductLiveSetTimeModalWrap>
        </ModalBody>
    );
};

const TimeOfDayPicker = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    border-radius: 6px;

    & > div {
        width: 60px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        color: #262626;
        cursor: pointer;

        &.on {
            color: #fff;
            background-color: rgb(200, 103, 51);
        }
    }
`;
//
const CustomDateInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const ReadOnlyInput = styled.input`
    outline: none;
    line-height: 16px;
    font-size: 20px;
    font-weight: 400;
    height: 35px;
    display: flex;
    align-items: center;
    background-color: rgb(200, 103, 51);
    justify-content: center;
    border-radius: 5px;
    color: #fff;
    padding: 5px 22px 6px;
    width: 155px;
`;

const CalendarButton = styled.button`
    background: none;
    border: none;
    width: 25px;
    height: 25px;
    cursor: pointer;

    img {
        width: 100%;
    }
`;
// --- Styled Components ---
const ModalBody = styled.div`
    background-color: #f6f6f6;
    padding: 32px;
    max-height: calc(90vh - 48px);
    overflow: auto;

    .react-datepicker__tab-loop {
        position: fixed;
        top: 106px;
    }
`;

const ProductLiveSetTimeModalWrap = styled.div`
    .btn_area {
        margin-top: 35px;
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: end;
    }

`;
const FieldWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
`;
const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    label {
        color: #222;
        font-size: 15px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: -0.16px;
    }
`;

const TimePicker = styled.div`
    display: flex;
    align-items: center;

    .time_divide {
        font-size: 14px;
        font-weight: 400;
        color: #222;
        padding: 0 5px;
    }
`;

const TimeControl = styled.div`
    display: flex;
    align-items: center;

    .time_input {
        outline: none;
        line-height: 16px;
        font-size: 20px;
        font-weight: 400;
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        background-color: rgb(200, 103, 51);
        justify-content: center;
        border-radius: 5px;
        color: #fff;
        padding: 5px 6px;
    }

    .time_sub_text {
        line-height: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #222;
        margin-left: 5px;
    }

    .time_control_wrap {
        display: flex;
        flex-direction: column;


        .time_control_btn {
            cursor: pointer;
            width: 10px;
            height: 5px;
            margin-left: 3px;

            &.up {

                border-bottom: solid 5px #242424;
                border-left: solid 5px transparent;
                border-right: solid 5px transparent;
            }

            &.dw {
                margin-top: 3px;
                border-top: solid 5px #242424;
                border-left: solid 5px transparent;
                border-right: solid 5px transparent;
            }
        }
    }
`;

export default ProductLiveSetTimeModal;
